import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative border-l border-gray-200"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-10 ml-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute w-3 h-3 bg-secondary-base rounded-full mt-1.5 -left-1.5" }, null, -1)
const _hoisted_4 = { class: "mb-2 text-base font-bold text-primary-base flex items-center" }
const _hoisted_5 = { class: "mr-3" }
const _hoisted_6 = {
  key: 0,
  class: "bg-primary-base rounded-2xl text-white py-1 px-2 text-xs"
}
const _hoisted_7 = { class: "mb-4 text-xs text-text-light font-regular" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Candidatou-se ao cargo de ")
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.currentHistory)
    ? (_openBlock(), _createElementBlock("ol", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.slice().reverse(), (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
            (item.result !== '2O TURNO')
              ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("time", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.year), 1),
                    (item.elected === true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Eleito(a)"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.post), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("h2", _hoisted_10, "Não há dados no histórico da pessoa candidata"))
}